import React from 'react';
import styled from 'styled-components';

const paths = {
  home: <><path d="M4 11L12 4l8 7" /><path d="M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9" /></>,
  clone: <><rect x="8" y="8" width="12" height="12" rx="1.5" /><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" /></>,
  upload: <><path d="M12 16V4M8 8l4-4 4 4" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></>,
  edit: <path d="M4 20h4L18.5 9.5a2.121 2.121 0 0 0-3-3L5 17v3z" />,
  zap: <path d="M13 2 4 14h6l-1 8 9-12h-6z" />,
  'thumbs-up': <><rect x="2" y="11" width="4" height="10" rx="1" /><path d="M9 21h7.5a2 2 0 0 0 2-1.6l1.2-6A2 2 0 0 0 17.7 11H13V6a2 2 0 0 0-2-2L9 9.5V21z" /></>,
  clipboard: <><rect x="6" y="4" width="12" height="17" rx="2" /><rect x="9" y="2" width="6" height="4" rx="1" /><path d="M9 11h6M9 15h6" /></>,
  target: <><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="1" /></>,
  trash: <><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13" /><path d="M10 11v6M14 11v6" /></>,
  'bar-chart': <path d="M4 20V10M10 20V4M16 20v-7M2 20h20" />,
  search: <><circle cx="10" cy="10" r="6" /><path d="M20 20l-5.5-5.5" /></>,
  lightbulb: <path d="M9 18h6M10 22h4M12 2a6 6 0 0 0-4 10.5c.8.8 1 1.3 1 2.5h6c0-1.2.2-1.7 1-2.5A6 6 0 0 0 12 2z" />,
  lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>,
  check: <path d="M5 12l5 5L19 8" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  'alert-triangle': <><path d="M12 3 2 20h20z" /><path d="M12 10v4M12 17h.01" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  refresh: <><path d="M4 4v6h6M20 20v-6h-6" /><path d="M20 10a8 8 0 0 0-14.6-4.6M4 14a8 8 0 0 0 14.6 4.6" /></>,
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />,
  rocket: <><path d="M12 2c3 2 5 6 5 10 0 2-1 4-2 5l-1 3-2-2-2 2-1-3c-1-1-2-3-2-5 0-4 2-8 5-10z" /><circle cx="12" cy="10" r="1.5" /><path d="M8 16l-3 3M16 16l3 3" /></>,
  wand: <><path d="M4 20L18 6" /><path d="M17 2l.7 2.3L20 5l-2.3.7L17 8l-.7-2.3L14 5l2.3-.7L17 2z" /></>,
  sparkles: <><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z" /><path d="M19 15l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" /></>,
  tool: <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2z" />,
  'file-text': <><path d="M6 3h9l3 3v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" /><path d="M9 11h6M9 15h6M9 7h3" /></>,
  offline: <><circle cx="12" cy="12" r="9" /><path d="M5 5l14 14" /></>,
  code: <path d="M9 6L3 12l6 6M15 6l6 6-6 6" />,
  'external-link': <><path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" /><path d="M14 4h6v6" /><path d="M10 14L20 4" /></>,
};

const Svg = styled.svg`
  flex-shrink: 0;
  display: block;
`;

const Icon = ({ name, size = 18, strokeWidth = 1.75, className }) => {
  const content = paths[name];
  if (!content) return null;

  return (
    <Svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {content}
    </Svg>
  );
};

export default Icon;
